module.exports = __webpack_public_path__ + "static/img/video-bg1.c604a8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video-bg1.jpg
// module id = T55U
// module chunks = 1